<template lang='pug'>
  .user-preference
    template(v-if='!full')
      .country-language-label(v-text='displayLanguage')
      select.country-language(v-model='currentLanguage' @change.prevent='setLanguagePreferences' v-if='currentLanguage.length > 0')
        option(v-for='(language, key) in languages' :value='key' v-text='language')

    template(v-else)
      ul.languages.dropdown(v-if='showLanguageOptions')
        li.dropdown-title
          p.h4 Select Language
        li.dropdown-option(v-for='(language, key) in languages')
          a.language(href='#' v-text='language' @click.prevent='setLanguagePreferences($event, key)')
</template>

<script>
import { mapState } from 'vuex'
import { sidebarUtil } from '@/mixins/layoutUtil'
import { clearApiCache } from '@/modules/service-workers/utilities'

export default {
  mixins: [
    sidebarUtil
  ],

  props: [
    'full'
  ],

  data () {
    return {
      currentLanguage: ''
    }
  },

  computed: {
    ...mapState({
      showLanguageOptions: state => state.layout.showLanguageOptions,
      currentUser: state => state.user.currentUser
    }),
    i18nSiteCountryLs: () => I18n.siteCountryLs,
    i18nLanguage: () => I18n.language,
    languages: () => vueSupport.header.languages,
    requestParams: () => vueSupport.header.requestParams,
    geoIpSession: () => vueSupport.header.geoIpSession,
    isMobile: () => vueSupport.isMobile,
    displayLanguage () {
      const language = Object.keys(this.languages).find(key => key !== this.i18nLanguage)
      return this.$t('navigation.links.changeLanguage', language)
    }
  },

  mounted () {
    this.initLanguage()
  },

  methods: {
    setLanguagePreferences (event, lang) {
      this.currentLanguage = lang || this.currentLanguage

      const isAdmin = this.currentUser && this.currentUser.attributes.admin

      const countryObj = Object.assign({}, {
        language_code: this.currentLanguage,
        iso_alpha2_code: this.geoIpSession || this.i18nSiteCountryLs,
        src_params: (this.full && isAdmin) ? this.requestParams : undefined,
        reload: true
      })

      if (this.isMobile) {
        this.closeSidebar()
      }

      window.htmlAxios.post('/user/change_preferences', {
        country: countryObj
      }).then((response) => {
        clearApiCache()
        window.location.reload()
      }).catch(console.trace)
    },

    initLanguage () {
      this.currentLanguage = this.i18nLanguage
    }
  }
}
</script>

<style scoped lang='scss'>
  .country-language {
    @include font-weight-bold;
    font-size: 16px;
    color: $black;
    text-transform: uppercase;
    border: 0;
    background: $white;
    outline: 0;
  }

  .country-language-label {
    width: 100%;
    position: absolute;
    pointer-events: none;
    background: $white;
  }

  .languages {
    position: absolute;
    border: 1px solid $grey;
    width: 160px;
    top: 35px;
    background: $white;
    padding: 10px 15px;
    z-index: $zindex-dropdown;
    text-align: left;

    .dropdown-title {
      @include font-weight-bold;
      color: $black;
      margin-bottom: 3px;
    }

    .dropdown-option {
      font-size: 12px;
      color: $black;

      .language {
        display: inline-block;
        vertical-align: middle;
        line-height: 18px;

        &:hover {
          color: $brand-primary;
        }
      }
    }
  }
</style>
